<template>
   <div
      id="top-container"
      class="q-pa-sm bg-white row items-center"
      :class="{ 'sticky-header': sticky }"
   >
      <h1 id="dashboard-title" class="text-h3 text-left text-bold">
         {{ props.title }}
      </h1>
      <div id="button-container">
         <UtmSourceSelector />
         <div id="all-date-container" class="row items-center no-wrap">
            <DatePickerSelector />
         </div>
      </div>
   </div>
</template>

<script setup lang="ts">
import UtmSourceSelector from "./UtmSourceSelector.vue"
import DatePickerSelector from "./DatePickerSelector.vue"

interface Props {
   title: string
   sticky?: boolean
}

const props = defineProps<Props>()
</script>

<style scoped lang="scss">
#top-container {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-items: center;
   width: 100%;
   gap: 1em;
   h1 {
      text-align: center;
      margin-top: 0.2em;
      margin-bottom: 0.2em;
   }

   &.sticky-header {
      position: sticky;
      top: 74px;
      z-index: 999;
      border-bottom: 1px solid #ccc;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
   }
}
#all-date-container {
   gap: 1em;
}
#button-container {
   display: flex;
   gap: 1em;
}
@media (max-width: 767px) {
   #button-container {
      width: 100%;
   }
   #header {
      h1 {
         font-size: 2rem;
      }
   }
}

@media (min-width: 768px) {
   #header {
      h1 {
         font-size: 3rem;
      }
   }
}
</style>
